import { ReportingComponent } from './common/reporting/reporting.component';
import {
  ConfirmationRespondentsDetailComponent
} from './user/confirmation-respondents/confirmation-respondents-detail/confirmation-respondents-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SurveyComponent } from './user/survey/survey.component';
import { SurveyListComponent } from './user/survey-list/survey-list.component';
import { FeedbackChatComponent } from './user/feedback-chat/feedback-chat.component';
import { MyTeamComponent } from './user/my-team/my-team.component';
import { MyPageComponent } from './user/my-page/my-page.component';
import { MyReportsComponent } from './user/my-page/my-reports/my-reports.component';
import { ConfirmationRespondentsListComponent } from './user/confirmation-respondents/confirmation-respondents-list.component';
import { RespondentsApprovalSearchPageComponent } from './user/respondents-approval-search-page/respondents-approval-search-page.component';
import { MyBuComponent } from './user/my-bu/my-bu.component';
import {
  RespondentsApprovalBusinessUnitSearchPageComponent
} from './user/respondents-approval-business-unit-search-page/respondents-approval-business-unit-search-page.component';
import {
  Except360ConfirmationRespondentsDetailComponent
} from './user/confirmation-respondents/except360-confirmation-respondents-detail/except360-confirmation-respondents-detail.component';
import { FeedbackChatBodyComponent } from './user/feedback-chat/feedback-chat-body/feedback-chat-body.component';
import { BuReportsComponent } from './user/my-bu/bu-reports/bu-reports.component';
import { FeedBackChatReportComponent } from './user/my-bu/bu-reports/feedback-chat-report/feedback-chat-report.component';
import { ProcessReportComponent } from './user/my-bu/bu-reports/process-report/process-report.component';
import {ProcessInfoReportComponent} from "./user/my-bu/bu-reports/process-info-report/process-info-report.component";
import { LoginComponent } from './common/login/login.component';
import { AuthGuard } from './guards/auth.guard';



const routes: Routes = [
  {
    path: 'user/survey-list', component: SurveyListComponent
  },
  { path: 'user/survey-list/survey', component: SurveyComponent },
  { path: 'user/feedback-chat', component: FeedbackChatComponent },
  {
    path: 'user/my-team',
    component: MyTeamComponent,
    children: [
      { path: '', component: ConfirmationRespondentsListComponent },
      { path: 'confirmations', component: ConfirmationRespondentsListComponent },
      { path: 'confirmations-detail/:id', component: ConfirmationRespondentsDetailComponent },
      { path: 'confirmations-bu-detail/:id', component: Except360ConfirmationRespondentsDetailComponent },
      { path: 'respondents-approval/:id', component: RespondentsApprovalSearchPageComponent },
      { path: 'my-reports', component: MyReportsComponent },
      { path: 'reports/report/:processId/:appraiseeId', component: ReportingComponent },
      { path: 'feedbacks', component: FeedbackChatBodyComponent },
      { path: 'business-units-approval/:id', component: RespondentsApprovalBusinessUnitSearchPageComponent },
    ]
  },
  {
    path: 'user/my-page',
    component: MyPageComponent,
    children: [
      { path: '', component: ConfirmationRespondentsListComponent },
      { path: 'self-assessment', component: SurveyListComponent },
      { path: 'self-assessment/survey', component: SurveyComponent },
      { path: 'confirmations', component: ConfirmationRespondentsListComponent },
      { path: 'confirmations-detail/:id', component: ConfirmationRespondentsDetailComponent },
      { path: 'my-reports', component: MyReportsComponent },
      { path: 'reports/report/:processId/:appraiseeId', component: ReportingComponent },
      { path: 'respondents-approval/:id', component: RespondentsApprovalSearchPageComponent },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'user/my-bu',
    component: MyBuComponent,
    children: [
      { path: '', redirectTo:'confirmations', pathMatch: 'full' },
      { path: 'confirmations', component: ConfirmationRespondentsListComponent },
      { path: 'confirmations-detail/:id', component: ConfirmationRespondentsDetailComponent },
      { path: 'confirmations-bu-detail/:id', component: Except360ConfirmationRespondentsDetailComponent },
      { path: 'respondents-approval/:id', component: RespondentsApprovalSearchPageComponent },
      { path: 'business-units-approval/:id', component: RespondentsApprovalBusinessUnitSearchPageComponent },
      { path: 'bu-reports', component: BuReportsComponent, children:[
        {path: '', redirectTo:'feedback-chat', pathMatch: 'full'},
        {path: 'feedback-chat', component: FeedBackChatReportComponent},
        {path: 'process-report', component: ProcessReportComponent},
        {path: 'process-info', component: ProcessInfoReportComponent}
      ]},
    ]
  },
  { path: "login", component: LoginComponent },
  { path: '', redirectTo: '/user/my-page', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
